import React from "react";
import { FaCircleInfo } from "react-icons/fa6";

// 챗 메시지 컴포넌트
const ChatMessage = ({ message, url }) => {
  const cleanMessage = (typeof message === 'string' && message) ? message.replace(/\\r/g, '') : message;
  
  const DISCLAIMER_TEXT = "본 메시지는 AI가 생성한 내용입니다.";

  const isStringMessage = typeof message === "string";
  const trimmedMessage = isStringMessage ? message.trimEnd() : message;

  const hasDisclaimer =
    isStringMessage && trimmedMessage.endsWith(DISCLAIMER_TEXT);

  // 안내 문구가 포함된 경우, 본문과 안내 문구를 분리해서 렌더링
  if (!url && hasDisclaimer) {
    const mainText = trimmedMessage.slice(
      0,
      trimmedMessage.length - DISCLAIMER_TEXT.length
    ).trimEnd();

    return (
      <div className="leading-tight break-all whitespace-pre-line">
        {mainText}
        <div className="flex text-sm font-medium tracking-tighter justify-start pt-2 items-center gap-1">
          <FaCircleInfo />
          <span className="flex text-sm font-medium tracking-tighter justify-start text-gray-500">{DISCLAIMER_TEXT}</span>
        </div>
      </div>
    );
  }

  return url ? (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="text-blue-500 underline break-all whitespace-pre-line"
    >
      {cleanMessage}
    </a>
  ) : (
    <p className="break-all whitespace-pre-line">{cleanMessage}</p>
  );
};

export default ChatMessage;
